export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5263.c8a655eb.jpg";